import { fetchGetNormalOfferPrices } from 'shared/repositories/mortgage-subsidised-offers/v1/get-normal-offer-prices';
import type { IEtazhiBlackFridayPricesData } from 'shared/types/etazhiBlackFriday';

import { mappers } from './utils';

import type { IGetEtazhiBlackFridayPriceParams } from './types';

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-251228
 */
export const getEtazhiBlackFridayPrice = async (
  params: IGetEtazhiBlackFridayPriceParams,
): Promise<IEtazhiBlackFridayPricesData | null> => {
  const { httpApi, logger, parameters } = params;

  try {
    const response = await fetchGetNormalOfferPrices({ httpApi, mappers, parameters });

    return response as IEtazhiBlackFridayPricesData;
  } catch (error) {
    logger.error(error, {
      description: 'Ошибка получения цен для промо-акции "Чёрная пятница" Этажи',
    });

    return null;
  }
};
